import http from "services/http";

export interface PopularDestination {
  _id: string;
  departure: string;
  destination: string;
  class: string;
  date: string;
  price: number;
  coverImage?: string;
}

export interface PopularDestinationsResponse {
  success: boolean;
  message: string;
  data: {
    items: PopularDestination[];
    pagination?: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      limit: number;
    };
  };
}

export const createPopularDestination = async (payload: FormData) => {
  const response = await http.post(
    "/admin/dashboard/popular-destinations",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const getPopularDestinations =
  async (): Promise<PopularDestinationsResponse> => {
    const response = await http.get("/admin/dashboard/popular-destinations");
    return response.data;
  };

export const updatePopularDestination = async (
  id: string,
  payload: FormData,
) => {
  const response = await http.patch(
    `/admin/dashboard/popular-destinations/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const deletePopularDestination = async (id: string) => {
  const response = await http.delete(
    `/admin/dashboard/popular-destinations/${id}`,
  );
  return response.data;
};
